export const MDF_INVENTORY_REQUEST = "MDF_INVENTORY_REQUEST";
export const MDF_INVENTORY_SUCCESS = "MDF_INVENTORY_SUCCESS";
export const MDF_INVENTORY_FAILED = "MDF_INVENTORY_FAILED";
export const MDF_HISTORY_REQUEST = "MDF_HISTORY_REQUEST";
export const MDF_HISTORY_SUCCESS = "MDF_HISTORY_SUCCESS";
export const MDF_HISTORY_FAILED = "MDF_HISTORY_FAILED";
